/* 
  Nulogy Design System Tokens
  THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY. 
*/

/*
|-----------------------------------------------------------------------------
| Border radius
|-----------------------------------------------------------------------------
*/
export const DESKTOP_BORDER_RADIUS_SMALL = '2px'
export const DESKTOP_BORDER_RADIUS_MEDIUM = '4px'
export const DESKTOP_BORDER_RADIUS_LARGE = '8px'
export const DESKTOP_BORDER_RADIUS_CIRCLE = '50%'
export const DESKTOP_BORDER_RADIUS_ROUNDED = '9999px'
export const TABLET_BORDER_RADIUS_SMALL = '2.8px'
export const TABLET_BORDER_RADIUS_MEDIUM = '5.6px'
export const TABLET_BORDER_RADIUS_LARGE = '11.2px'
export const TABLET_BORDER_RADIUS_CIRCLE = '50%'
export const TABLET_BORDER_RADIUS_ROUNDED = '9999px'
export const PHONE_BORDER_RADIUS_SMALL = '1.8px'
export const PHONE_BORDER_RADIUS_MEDIUM = '3.6px'
export const PHONE_BORDER_RADIUS_LARGE = '7.2px'
export const PHONE_BORDER_RADIUS_CIRCLE = '50%'
export const PHONE_BORDER_RADIUS_ROUNDED = '9999px'

/*
|-----------------------------------------------------------------------------
| Breakpoints
|-----------------------------------------------------------------------------
*/
export const DESKTOP_BREAKPOINTS_BASE_EXTRA_SMALL = '0px'
export const DESKTOP_BREAKPOINTS_BASE_SMALL = '768px'
export const DESKTOP_BREAKPOINTS_BASE_MEDIUM = '1024px'
export const DESKTOP_BREAKPOINTS_BASE_LARGE = '1360px'
export const DESKTOP_BREAKPOINTS_BASE_EXTRA_LARGE = '1920px'
export const DESKTOP_BREAKPOINTS_SEMANTIC_PHONE_PORTRAIT = '320px'
export const DESKTOP_BREAKPOINTS_SEMANTIC_PHONE_LANDSCAPE = '640px'
export const DESKTOP_BREAKPOINTS_SEMANTIC_TABLET_PORTRAIT = '768px'
export const DESKTOP_BREAKPOINTS_SEMANTIC_TABLET_LANDSCAPE = '1024px'
export const DESKTOP_BREAKPOINTS_SEMANTIC_LAPTOP = '1280px'
export const DESKTOP_BREAKPOINTS_SEMANTIC_DESKTOP = '1440px'
export const TABLET_BREAKPOINTS_BASE_EXTRA_SMALL = '0px'
export const TABLET_BREAKPOINTS_BASE_SMALL = '768px'
export const TABLET_BREAKPOINTS_BASE_MEDIUM = '1024px'
export const TABLET_BREAKPOINTS_BASE_LARGE = '1360px'
export const TABLET_BREAKPOINTS_BASE_EXTRA_LARGE = '1920px'
export const TABLET_BREAKPOINTS_SEMANTIC_PHONE_PORTRAIT = '320px'
export const TABLET_BREAKPOINTS_SEMANTIC_PHONE_LANDSCAPE = '640px'
export const TABLET_BREAKPOINTS_SEMANTIC_TABLET_PORTRAIT = '768px'
export const TABLET_BREAKPOINTS_SEMANTIC_TABLET_LANDSCAPE = '1024px'
export const TABLET_BREAKPOINTS_SEMANTIC_LAPTOP = '1280px'
export const TABLET_BREAKPOINTS_SEMANTIC_DESKTOP = '1440px'
export const PHONE_BREAKPOINTS_BASE_EXTRA_SMALL = '0px'
export const PHONE_BREAKPOINTS_BASE_SMALL = '768px'
export const PHONE_BREAKPOINTS_BASE_MEDIUM = '1024px'
export const PHONE_BREAKPOINTS_BASE_LARGE = '1360px'
export const PHONE_BREAKPOINTS_BASE_EXTRA_LARGE = '1920px'
export const PHONE_BREAKPOINTS_SEMANTIC_PHONE_PORTRAIT = '320px'
export const PHONE_BREAKPOINTS_SEMANTIC_PHONE_LANDSCAPE = '640px'
export const PHONE_BREAKPOINTS_SEMANTIC_TABLET_PORTRAIT = '768px'
export const PHONE_BREAKPOINTS_SEMANTIC_TABLET_LANDSCAPE = '1024px'
export const PHONE_BREAKPOINTS_SEMANTIC_LAPTOP = '1280px'
export const PHONE_BREAKPOINTS_SEMANTIC_DESKTOP = '1440px'

/*
|-----------------------------------------------------------------------------
| Color
|-----------------------------------------------------------------------------
*/
export const DESKTOP_COLOR_BASE_BLACK = '#011E38'
export const DESKTOP_COLOR_BASE_BLACK_BLUE = '#122B47'
export const DESKTOP_COLOR_BASE_DARK_BLUE = '#00438F'
export const DESKTOP_COLOR_BASE_BLUE = '#216BEB'
export const DESKTOP_COLOR_BASE_LIGHT_BLUE = '#E1EBFA'
export const DESKTOP_COLOR_BASE_DARK_GREY = '#434D59'
export const DESKTOP_COLOR_BASE_MID_GREY = '#6C7784'
export const DESKTOP_COLOR_BASE_GREY = '#C0C8D1'
export const DESKTOP_COLOR_BASE_LIGHT_GREY = '#E4E7EB'
export const DESKTOP_COLOR_BASE_WHITE_GREY = '#F0F2F5'
export const DESKTOP_COLOR_BASE_WHITE = '#FFFFFF'
export const DESKTOP_COLOR_BASE_GREEN = '#008059'
export const DESKTOP_COLOR_BASE_LIGHT_GREEN = '#E9F7F2'
export const DESKTOP_COLOR_BASE_RED = '#CC1439'
export const DESKTOP_COLOR_BASE_LIGHT_RED = '#FAE6EA'
export const DESKTOP_COLOR_BASE_YELLOW = '#FFBB00'
export const DESKTOP_COLOR_BASE_LIGHT_YELLOW = '#FCF5E3'
export const DESKTOP_COLOR_BASE_AQUA = '#19C4E6'
export const DESKTOP_COLOR_BASE_PURPLE = '#8033CC'
export const DESKTOP_COLOR_BASE_PINK = '#E372D0'
export const DESKTOP_COLOR_BASE_TURQUOISE = '#55DDB0'
export const DESKTOP_COLOR_BASE_ORANGE = '#EE5513'
export const DESKTOP_COLOR_BASE_AVOCADO = '#D3D322'
export const DESKTOP_COLOR_CATEGORICAL_1 = '#19C4E6'
export const DESKTOP_COLOR_CATEGORICAL_2 = '#8033CC'
export const DESKTOP_COLOR_CATEGORICAL_3 = '#E372D0'
export const DESKTOP_COLOR_CATEGORICAL_4 = '#55DDB0'
export const DESKTOP_COLOR_CATEGORICAL_5 = '#EE5513'
export const DESKTOP_COLOR_CATEGORICAL_6 = '#D3D322'
export const TABLET_COLOR_BASE_BLACK = '#011E38'
export const TABLET_COLOR_BASE_BLACK_BLUE = '#122B47'
export const TABLET_COLOR_BASE_DARK_BLUE = '#00438F'
export const TABLET_COLOR_BASE_BLUE = '#216BEB'
export const TABLET_COLOR_BASE_LIGHT_BLUE = '#E1EBFA'
export const TABLET_COLOR_BASE_DARK_GREY = '#434D59'
export const TABLET_COLOR_BASE_MID_GREY = '#6C7784'
export const TABLET_COLOR_BASE_GREY = '#C0C8D1'
export const TABLET_COLOR_BASE_LIGHT_GREY = '#E4E7EB'
export const TABLET_COLOR_BASE_WHITE_GREY = '#F0F2F5'
export const TABLET_COLOR_BASE_WHITE = '#FFFFFF'
export const TABLET_COLOR_BASE_GREEN = '#008059'
export const TABLET_COLOR_BASE_LIGHT_GREEN = '#E9F7F2'
export const TABLET_COLOR_BASE_RED = '#CC1439'
export const TABLET_COLOR_BASE_LIGHT_RED = '#FAE6EA'
export const TABLET_COLOR_BASE_YELLOW = '#FFBB00'
export const TABLET_COLOR_BASE_LIGHT_YELLOW = '#FCF5E3'
export const TABLET_COLOR_BASE_AQUA = '#19C4E6'
export const TABLET_COLOR_BASE_PURPLE = '#8033CC'
export const TABLET_COLOR_BASE_PINK = '#E372D0'
export const TABLET_COLOR_BASE_TURQUOISE = '#55DDB0'
export const TABLET_COLOR_BASE_ORANGE = '#EE5513'
export const TABLET_COLOR_BASE_AVOCADO = '#D3D322'
export const TABLET_COLOR_CATEGORICAL_1 = '#19C4E6'
export const TABLET_COLOR_CATEGORICAL_2 = '#8033CC'
export const TABLET_COLOR_CATEGORICAL_3 = '#E372D0'
export const TABLET_COLOR_CATEGORICAL_4 = '#55DDB0'
export const TABLET_COLOR_CATEGORICAL_5 = '#EE5513'
export const TABLET_COLOR_CATEGORICAL_6 = '#D3D322'
export const PHONE_COLOR_BASE_BLACK = '#011E38'
export const PHONE_COLOR_BASE_BLACK_BLUE = '#122B47'
export const PHONE_COLOR_BASE_DARK_BLUE = '#00438F'
export const PHONE_COLOR_BASE_BLUE = '#216BEB'
export const PHONE_COLOR_BASE_LIGHT_BLUE = '#E1EBFA'
export const PHONE_COLOR_BASE_DARK_GREY = '#434D59'
export const PHONE_COLOR_BASE_MID_GREY = '#6C7784'
export const PHONE_COLOR_BASE_GREY = '#C0C8D1'
export const PHONE_COLOR_BASE_LIGHT_GREY = '#E4E7EB'
export const PHONE_COLOR_BASE_WHITE_GREY = '#F0F2F5'
export const PHONE_COLOR_BASE_WHITE = '#FFFFFF'
export const PHONE_COLOR_BASE_GREEN = '#008059'
export const PHONE_COLOR_BASE_LIGHT_GREEN = '#E9F7F2'
export const PHONE_COLOR_BASE_RED = '#CC1439'
export const PHONE_COLOR_BASE_LIGHT_RED = '#FAE6EA'
export const PHONE_COLOR_BASE_YELLOW = '#FFBB00'
export const PHONE_COLOR_BASE_LIGHT_YELLOW = '#FCF5E3'
export const PHONE_COLOR_BASE_AQUA = '#19C4E6'
export const PHONE_COLOR_BASE_PURPLE = '#8033CC'
export const PHONE_COLOR_BASE_PINK = '#E372D0'
export const PHONE_COLOR_BASE_TURQUOISE = '#55DDB0'
export const PHONE_COLOR_BASE_ORANGE = '#EE5513'
export const PHONE_COLOR_BASE_AVOCADO = '#D3D322'
export const PHONE_COLOR_CATEGORICAL_1 = '#19C4E6'
export const PHONE_COLOR_CATEGORICAL_2 = '#8033CC'
export const PHONE_COLOR_CATEGORICAL_3 = '#E372D0'
export const PHONE_COLOR_CATEGORICAL_4 = '#55DDB0'
export const PHONE_COLOR_CATEGORICAL_5 = '#EE5513'
export const PHONE_COLOR_CATEGORICAL_6 = '#D3D322'

/*
|-----------------------------------------------------------------------------
| Font family
|-----------------------------------------------------------------------------
*/
export const DESKTOP_FONT_FAMILY_BASE = "'IBM Plex Sans', sans-serif"
export const DESKTOP_FONT_FAMILY_MONO = "'IBM Plex Mono', monospace"
export const DESKTOP_FONT_FAMILY_SC = "'Noto Sans SC', sans-serif"
export const DESKTOP_FONT_FAMILY_JP = "'IBM Plex Sans JP', sans-serif"
export const TABLET_FONT_FAMILY_BASE = "'IBM Plex Sans', sans-serif"
export const TABLET_FONT_FAMILY_MONO = "'IBM Plex Mono', monospace"
export const TABLET_FONT_FAMILY_SC = "'Noto Sans SC', sans-serif"
export const TABLET_FONT_FAMILY_JP = "'IBM Plex Sans JP', sans-serif"
export const PHONE_FONT_FAMILY_BASE = "'IBM Plex Sans', sans-serif"
export const PHONE_FONT_FAMILY_MONO = "'IBM Plex Mono', monospace"
export const PHONE_FONT_FAMILY_SC = "'Noto Sans SC', sans-serif"
export const PHONE_FONT_FAMILY_JP = "'IBM Plex Sans JP', sans-serif"

/*
|-----------------------------------------------------------------------------
| Font size
|-----------------------------------------------------------------------------
*/
export const DESKTOP_FONT_SIZE_STANDARD_SMALLER = '12px'
export const DESKTOP_FONT_SIZE_STANDARD_SMALL = '15px'
export const DESKTOP_FONT_SIZE_STANDARD_MEDIUM = '15px'
export const DESKTOP_FONT_SIZE_STANDARD_LARGE = '21px'
export const DESKTOP_FONT_SIZE_STANDARD_LARGER = '24px'
export const DESKTOP_FONT_SIZE_STANDARD_LARGEST = '30px'
export const DESKTOP_FONT_SIZE_EXPERIMENTAL_XXS = '9px'
export const DESKTOP_FONT_SIZE_EXPERIMENTAL_XS = '12px'
export const DESKTOP_FONT_SIZE_EXPERIMENTAL_SM = '15px'
export const DESKTOP_FONT_SIZE_EXPERIMENTAL_MD = '18px'
export const DESKTOP_FONT_SIZE_EXPERIMENTAL_LG = '21px'
export const DESKTOP_FONT_SIZE_EXPERIMENTAL_XL = '24px'
export const DESKTOP_FONT_SIZE_EXPERIMENTAL_XXL = '30px'
export const DESKTOP_FONT_SIZE_SEMANTIC_HEADING_1 = '24px'
export const DESKTOP_FONT_SIZE_SEMANTIC_HEADING_2 = '21px'
export const DESKTOP_FONT_SIZE_SEMANTIC_HEADING_3 = '15px'
export const DESKTOP_FONT_SIZE_SEMANTIC_HEADING_4 = '15px'
export const DESKTOP_FONT_SIZE_SEMANTIC_BASE = '15px'
export const TABLET_FONT_SIZE_STANDARD_SMALLER = '16.8px'
export const TABLET_FONT_SIZE_STANDARD_SMALL = '21px'
export const TABLET_FONT_SIZE_STANDARD_MEDIUM = '21px'
export const TABLET_FONT_SIZE_STANDARD_LARGE = '29.4px'
export const TABLET_FONT_SIZE_STANDARD_LARGER = '33.6px'
export const TABLET_FONT_SIZE_STANDARD_LARGEST = '42px'
export const TABLET_FONT_SIZE_EXPERIMENTAL_XXS = '12.6px'
export const TABLET_FONT_SIZE_EXPERIMENTAL_XS = '16.8px'
export const TABLET_FONT_SIZE_EXPERIMENTAL_SM = '21px'
export const TABLET_FONT_SIZE_EXPERIMENTAL_MD = '25.2px'
export const TABLET_FONT_SIZE_EXPERIMENTAL_LG = '29.4px'
export const TABLET_FONT_SIZE_EXPERIMENTAL_XL = '33.6px'
export const TABLET_FONT_SIZE_EXPERIMENTAL_XXL = '42px'
export const TABLET_FONT_SIZE_SEMANTIC_HEADING_1 = '33.6px'
export const TABLET_FONT_SIZE_SEMANTIC_HEADING_2 = '29.4px'
export const TABLET_FONT_SIZE_SEMANTIC_HEADING_3 = '21px'
export const TABLET_FONT_SIZE_SEMANTIC_HEADING_4 = '21px'
export const TABLET_FONT_SIZE_SEMANTIC_BASE = '21px'
export const PHONE_FONT_SIZE_STANDARD_SMALLER = '10.8px'
export const PHONE_FONT_SIZE_STANDARD_SMALL = '13.5px'
export const PHONE_FONT_SIZE_STANDARD_MEDIUM = '13.5px'
export const PHONE_FONT_SIZE_STANDARD_LARGE = '18.9px'
export const PHONE_FONT_SIZE_STANDARD_LARGER = '21.6px'
export const PHONE_FONT_SIZE_STANDARD_LARGEST = '27px'
export const PHONE_FONT_SIZE_EXPERIMENTAL_XXS = '8.1px'
export const PHONE_FONT_SIZE_EXPERIMENTAL_XS = '10.8px'
export const PHONE_FONT_SIZE_EXPERIMENTAL_SM = '13.5px'
export const PHONE_FONT_SIZE_EXPERIMENTAL_MD = '16.2px'
export const PHONE_FONT_SIZE_EXPERIMENTAL_LG = '18.9px'
export const PHONE_FONT_SIZE_EXPERIMENTAL_XL = '21.6px'
export const PHONE_FONT_SIZE_EXPERIMENTAL_XXL = '27px'
export const PHONE_FONT_SIZE_SEMANTIC_HEADING_1 = '21.6px'
export const PHONE_FONT_SIZE_SEMANTIC_HEADING_2 = '18.9px'
export const PHONE_FONT_SIZE_SEMANTIC_HEADING_3 = '13.5px'
export const PHONE_FONT_SIZE_SEMANTIC_HEADING_4 = '13.5px'
export const PHONE_FONT_SIZE_SEMANTIC_BASE = '13.5px'

/*
|-----------------------------------------------------------------------------
| Font weight
|-----------------------------------------------------------------------------
*/
export const DESKTOP_FONT_WEIGHT_LIGHT = 300
export const DESKTOP_FONT_WEIGHT_NORMAL = 400
export const DESKTOP_FONT_WEIGHT_MEDIUM = 500
export const DESKTOP_FONT_WEIGHT_BOLD = 600
export const TABLET_FONT_WEIGHT_LIGHT = 300
export const TABLET_FONT_WEIGHT_NORMAL = 400
export const TABLET_FONT_WEIGHT_MEDIUM = 500
export const TABLET_FONT_WEIGHT_BOLD = 600
export const PHONE_FONT_WEIGHT_LIGHT = 300
export const PHONE_FONT_WEIGHT_NORMAL = 400
export const PHONE_FONT_WEIGHT_MEDIUM = 500
export const PHONE_FONT_WEIGHT_BOLD = 600

/*
|-----------------------------------------------------------------------------
| Line height
|-----------------------------------------------------------------------------
*/
export const DESKTOP_LINE_HEIGHT_BASE = '1.3333'
export const DESKTOP_LINE_HEIGHT_BASE_RELAXED = '1.6'
export const DESKTOP_LINE_HEIGHT_SMALL_TEXT_BASE = '1.3333'
export const DESKTOP_LINE_HEIGHT_SMALL_TEXT_COMPRESSED = '1.3333'
export const DESKTOP_LINE_HEIGHT_SMALL_RELAXED = '1.6'
export const DESKTOP_LINE_HEIGHT_SMALLER_TEXT = '1.3333'
export const DESKTOP_LINE_HEIGHT_SMALLER_RELAXED = '1.6667'
export const DESKTOP_LINE_HEIGHT_HEADING_1 = '1.3333'
export const DESKTOP_LINE_HEIGHT_HEADING_2 = '1.3333'
export const DESKTOP_LINE_HEIGHT_HEADING_3 = '1.6'
export const DESKTOP_LINE_HEIGHT_HEADING_4 = '1.3333'
export const DESKTOP_LINE_HEIGHT_TITLE = '1.3333'
export const DESKTOP_LINE_HEIGHT_SECTION_TITLE = '1.3333'
export const DESKTOP_LINE_HEIGHT_SUBSECTION_TITLE = '1.6'
export const TABLET_LINE_HEIGHT_BASE = '1.3333'
export const TABLET_LINE_HEIGHT_BASE_RELAXED = '1.6'
export const TABLET_LINE_HEIGHT_SMALL_TEXT_BASE = '1.3333'
export const TABLET_LINE_HEIGHT_SMALL_TEXT_COMPRESSED = '1.3333'
export const TABLET_LINE_HEIGHT_SMALL_RELAXED = '1.6'
export const TABLET_LINE_HEIGHT_SMALLER_TEXT = '1.3333'
export const TABLET_LINE_HEIGHT_SMALLER_RELAXED = '1.6667'
export const TABLET_LINE_HEIGHT_HEADING_1 = '1.3333'
export const TABLET_LINE_HEIGHT_HEADING_2 = '1.3333'
export const TABLET_LINE_HEIGHT_HEADING_3 = '1.6'
export const TABLET_LINE_HEIGHT_HEADING_4 = '1.3333'
export const TABLET_LINE_HEIGHT_TITLE = '1.3333'
export const TABLET_LINE_HEIGHT_SECTION_TITLE = '1.3333'
export const TABLET_LINE_HEIGHT_SUBSECTION_TITLE = '1.6'
export const PHONE_LINE_HEIGHT_BASE = '1.3333'
export const PHONE_LINE_HEIGHT_BASE_RELAXED = '1.6'
export const PHONE_LINE_HEIGHT_SMALL_TEXT_BASE = '1.3333'
export const PHONE_LINE_HEIGHT_SMALL_TEXT_COMPRESSED = '1.3333'
export const PHONE_LINE_HEIGHT_SMALL_RELAXED = '1.6'
export const PHONE_LINE_HEIGHT_SMALLER_TEXT = '1.3333'
export const PHONE_LINE_HEIGHT_SMALLER_RELAXED = '1.6667'
export const PHONE_LINE_HEIGHT_HEADING_1 = '1.3333'
export const PHONE_LINE_HEIGHT_HEADING_2 = '1.3333'
export const PHONE_LINE_HEIGHT_HEADING_3 = '1.6'
export const PHONE_LINE_HEIGHT_HEADING_4 = '1.3333'
export const PHONE_LINE_HEIGHT_TITLE = '1.3333'
export const PHONE_LINE_HEIGHT_SECTION_TITLE = '1.3333'
export const PHONE_LINE_HEIGHT_SUBSECTION_TITLE = '1.6'

/*
|-----------------------------------------------------------------------------
| Shadow
|-----------------------------------------------------------------------------
*/
export const DESKTOP_SHADOW_SMALL = '0px 1px 2px 0px rgba(1, 30, 56, 0.25)'
export const DESKTOP_SHADOW_MEDIUM = '0px 3px 8px 0px rgba(1, 30, 56, 0.18)'
export const DESKTOP_SHADOW_LARGE = '0px 6px 12px 2px rgba(1, 30, 56, 0.15)'
export const DESKTOP_SHADOW_FOCUS = '0px 0px 5px 0px rgba(33, 107, 235, .9)'
export const DESKTOP_SHADOW_ERROR = '0px 0px 5px 0px rgba(204, 20, 57, .9)'
export const TABLET_SHADOW_SMALL = '0px 1px 2px 0px rgba(1, 30, 56, 0.25)'
export const TABLET_SHADOW_MEDIUM = '0px 3px 8px 0px rgba(1, 30, 56, 0.18)'
export const TABLET_SHADOW_LARGE = '0px 6px 12px 2px rgba(1, 30, 56, 0.15)'
export const TABLET_SHADOW_FOCUS = '0px 0px 5px 0px rgba(33, 107, 235, .9)'
export const TABLET_SHADOW_ERROR = '0px 0px 5px 0px rgba(204, 20, 57, .9)'
export const PHONE_SHADOW_SMALL = '0px 1px 2px 0px rgba(1, 30, 56, 0.25)'
export const PHONE_SHADOW_MEDIUM = '0px 3px 8px 0px rgba(1, 30, 56, 0.18)'
export const PHONE_SHADOW_LARGE = '0px 6px 12px 2px rgba(1, 30, 56, 0.15)'
export const PHONE_SHADOW_FOCUS = '0px 0px 5px 0px rgba(33, 107, 235, .9)'
export const PHONE_SHADOW_ERROR = '0px 0px 5px 0px rgba(204, 20, 57, .9)'

/*
|-----------------------------------------------------------------------------
| Space
|-----------------------------------------------------------------------------
*/
export const DESKTOP_SPACE_NONE = '0px'
export const DESKTOP_SPACE_X_0 = '0px'
export const DESKTOP_SPACE_X_0_25 = '2px'
export const DESKTOP_SPACE_HALF = '4px'
export const DESKTOP_SPACE_X_0_5 = '4px'
export const DESKTOP_SPACE_X_0_75 = '6px'
export const DESKTOP_SPACE_X_1 = '8px'
export const DESKTOP_SPACE_X_1_25 = '10px'
export const DESKTOP_SPACE_X_1_5 = '12px'
export const DESKTOP_SPACE_X_1_75 = '14px'
export const DESKTOP_SPACE_X_2 = '16px'
export const DESKTOP_SPACE_X_2_5 = '20px'
export const DESKTOP_SPACE_X_3 = '24px'
export const DESKTOP_SPACE_X_4 = '32px'
export const DESKTOP_SPACE_X_5 = '40px'
export const DESKTOP_SPACE_X_6 = '48px'
export const DESKTOP_SPACE_X_7 = '56px'
export const DESKTOP_SPACE_X_8 = '64px'
export const DESKTOP_SPACE_X_9 = '72px'
export const DESKTOP_SPACE_X_10 = '80px'
export const DESKTOP_SPACE_X_11 = '88px'
export const DESKTOP_SPACE_X_12 = '96px'
export const TABLET_SPACE_NONE = '0px'
export const TABLET_SPACE_X_0 = '0px'
export const TABLET_SPACE_X_0_25 = '2.8px'
export const TABLET_SPACE_HALF = '5.6px'
export const TABLET_SPACE_X_0_5 = '5.6px'
export const TABLET_SPACE_X_0_75 = '8.4px'
export const TABLET_SPACE_X_1 = '11.2px'
export const TABLET_SPACE_X_1_25 = '14px'
export const TABLET_SPACE_X_1_5 = '16.8px'
export const TABLET_SPACE_X_1_75 = '19.6px'
export const TABLET_SPACE_X_2 = '22.4px'
export const TABLET_SPACE_X_2_5 = '28px'
export const TABLET_SPACE_X_3 = '33.6px'
export const TABLET_SPACE_X_4 = '44.8px'
export const TABLET_SPACE_X_5 = '56px'
export const TABLET_SPACE_X_6 = '67.2px'
export const TABLET_SPACE_X_7 = '78.4px'
export const TABLET_SPACE_X_8 = '89.6px'
export const TABLET_SPACE_X_9 = '100.8px'
export const TABLET_SPACE_X_10 = '112px'
export const TABLET_SPACE_X_11 = '123.2px'
export const TABLET_SPACE_X_12 = '134.4px'
export const PHONE_SPACE_NONE = '0px'
export const PHONE_SPACE_X_0 = '0px'
export const PHONE_SPACE_X_0_25 = '1.8px'
export const PHONE_SPACE_HALF = '3.6px'
export const PHONE_SPACE_X_0_5 = '3.6px'
export const PHONE_SPACE_X_0_75 = '5.4px'
export const PHONE_SPACE_X_1 = '7.2px'
export const PHONE_SPACE_X_1_25 = '9px'
export const PHONE_SPACE_X_1_5 = '10.8px'
export const PHONE_SPACE_X_1_75 = '12.6px'
export const PHONE_SPACE_X_2 = '14.4px'
export const PHONE_SPACE_X_2_5 = '18px'
export const PHONE_SPACE_X_3 = '21.6px'
export const PHONE_SPACE_X_4 = '28.8px'
export const PHONE_SPACE_X_5 = '36px'
export const PHONE_SPACE_X_6 = '43.2px'
export const PHONE_SPACE_X_7 = '50.4px'
export const PHONE_SPACE_X_8 = '57.6px'
export const PHONE_SPACE_X_9 = '64.8px'
export const PHONE_SPACE_X_10 = '72px'
export const PHONE_SPACE_X_11 = '79.2px'
export const PHONE_SPACE_X_12 = '86.4px'

/*
|-----------------------------------------------------------------------------
| Z index
|-----------------------------------------------------------------------------
*/
export const DESKTOP_Z_INDEX_MODAL_HEADER_AND_FOOTER = 2
export const DESKTOP_Z_INDEX_TABLE_HEADER = 10
export const DESKTOP_Z_INDEX_CONTENT = 100
export const DESKTOP_Z_INDEX_TABS_SCROLL_INDICATOR = 200
export const DESKTOP_Z_INDEX_TABS_BAR = 210
export const DESKTOP_Z_INDEX_NAV_BAR = 900
export const DESKTOP_Z_INDEX_SIDEBAR = 800
export const DESKTOP_Z_INDEX_OVERLAY = 1000
export const DESKTOP_Z_INDEX_OPEN_CONTROL = 1000
export const DESKTOP_Z_INDEX_ABOVE_OVERLAY = 1010
export const TABLET_Z_INDEX_MODAL_HEADER_AND_FOOTER = 2
export const TABLET_Z_INDEX_TABLE_HEADER = 10
export const TABLET_Z_INDEX_CONTENT = 100
export const TABLET_Z_INDEX_TABS_SCROLL_INDICATOR = 200
export const TABLET_Z_INDEX_TABS_BAR = 210
export const TABLET_Z_INDEX_NAV_BAR = 900
export const TABLET_Z_INDEX_SIDEBAR = 800
export const TABLET_Z_INDEX_OVERLAY = 1000
export const TABLET_Z_INDEX_OPEN_CONTROL = 1000
export const TABLET_Z_INDEX_ABOVE_OVERLAY = 1010
export const PHONE_Z_INDEX_MODAL_HEADER_AND_FOOTER = 2
export const PHONE_Z_INDEX_TABLE_HEADER = 10
export const PHONE_Z_INDEX_CONTENT = 100
export const PHONE_Z_INDEX_TABS_SCROLL_INDICATOR = 200
export const PHONE_Z_INDEX_TABS_BAR = 210
export const PHONE_Z_INDEX_NAV_BAR = 900
export const PHONE_Z_INDEX_SIDEBAR = 800
export const PHONE_Z_INDEX_OVERLAY = 1000
export const PHONE_Z_INDEX_OPEN_CONTROL = 1000
export const PHONE_Z_INDEX_ABOVE_OVERLAY = 1010
